import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/orderDetail/importer/orderDetailImporterActions'

export default importerReducers(actions)
